import React from 'react';
import { connect } from 'react-redux';

import CurrencyConversionComponent from '../components/currency-conversion';
import { getCurrentPurchase } from '../selectors/purchase-selector';
import Purchase from '../lib/purchase';

const CurrencyConversion = ({ amount, processingCurrencyCode, currencyCode, conversionRate }) => {
  if (processingCurrencyCode === currencyCode) return null;
  if (!conversionRate) return null;

  return (
    <CurrencyConversionComponent
      processingCurrencyCode={processingCurrencyCode}
      conversionRate={conversionRate}
      currencyCode={currencyCode}
      amount={amount}
    />
  );
};

CurrencyConversion.defaultProps = {
  processingCurrencyCode: 'USD',
  currencyCode: 'USD',
  conversionRate: 1,
};

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const payment = Purchase.getCurrentOrLastPayment(purchase);

  return {
    processingCurrencyCode: payment.processingCurrency,
    conversionRate: payment.conversionRate,
    currencyCode: purchase.currencyCode,
  };
};

export default connect(mapStateToProps)(CurrencyConversion);



// WEBPACK FOOTER //
// ./src/desktop/containers/currency-conversion.container.js